import axios from "axios"
import queryString from "query-string"
import {setCookie, getCookie} from "./common";



let baseURL = ""

// axios.defaults.timeout = 100000;

if (process.env.NODE_ENV === 'development') {
    // baseURL = 'http://10.80.7.115';
} else {
   // baseUrl = 'http://localhost:7001';
}

axios.defaults.baseURL = baseURL;//请求地址设置
// 配置请求拦截
axios.interceptors.request.use(config => {
    // config.setHeaders([
    //   // 在这里设置请求头与携带token信息
    // ]);
    // in prod default to api host in config
    if (process.env.NODE_ENV === 'production') {
      config.baseURL = process.env.API_HOST
    }
    // console.log(config, 'config')
    let token = getCookie('token');
    // // if(!(config.headers.Authorization)) {
    if(token) {
      config.headers.Authorization ="Bearer " + token;
    }

    // }
    return config;
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(
    function(response) {
      let url = response.request.responseURL||response.config.url;
      if(url.indexOf("/login")>-1){
        let username = (response.data && response.data.data && response.data.data.username != null) ? response.data.data.username : null
        localStorage.setItem('username',username)
        let nickname = (response.data && response.data.data && response.data.data.nickname != null) ? response.data.data.nickname : null
        localStorage.setItem('nickname',nickname)
        let profilePicture = (response.data && response.data.data && response.data.data.profilePicture != null) ? response.data.data.profilePicture : null
        localStorage.setItem('profilePicture',profilePicture)
      }
      let token = (response.data && response.data.token != null) ? response.data.token : null;
      if(token){
        localStorage.setItem('token',token);
        setCookie('token',token);
      }
      return response;
    },
    function(error) {
      // 对响应错误做点什么
      return Promise.reject(error);
    }
);

const urlConfig = {
  url: ''
}
if (process.env.NODE_ENV === 'development') {
  urlConfig.url = '/api'
} else {
  urlConfig.url = '/api'
}

/**
 * get请求
 * @method get
 * @param {url, params, loading} 请求地址，请求参数，是否需要加载层
 */
let get = function(url, params, headers, loading) {
    return new Promise((resolve, reject) => {
      // {
      //   params: params
      // }
      axios
        .get(url, {params, 'headers': { 'Content-Type': 'application/json; charset=utf-8', ...headers}})
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          resolve(err);
        });
    });
};

/**
 * post请求
 * @method post
 * @param {url, params} 请求地址，请求参数，是否需要加载层
 */
let post = function(url, data, headers) {
    // let params = queryString.stringify(data)
    return new Promise((resolve, reject) => {
      // qs.stringify(data)
      axios
        .post(url, data, { 'headers': { 'Content-Type': 'application/json; charset=utf-8', ...headers} })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
};

let put = function(url, data, headers) {
  // let params = queryString.stringify(data)
  return new Promise((resolve, reject) => {
    // qs.stringify(data)
    axios
      .put(url, data, { 'headers': { 'Content-Type': 'application/json; charset=utf-8', ...headers} })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

let httpDelete = function(url, data, headersParams) {
  // let params = queryString.stringify(data)
  let headers = { data, 'headers': { 'Content-Type': 'application/json; charset=utf-8', ...headersParams } }
  return new Promise((resolve, reject) => {
    // qs.stringify(data)
    axios
      .delete(url, headers)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};
let postFile = function(url, data, headers) {
  return new Promise((resolve, reject) => {
    // qs.stringify(data)
    axios
      .post(url, { data: qs.stringify(data) }, { 'headers': { 'Content-Type': 'application/json; charset=utf-8', ...headers} })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
export  { get, post, put, httpDelete, postFile, urlConfig };




// WEBPACK FOOTER //
// ./src/utils/request.js